import React, { Component } from 'react'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import { getPaginationConfig } from '../../../components/pagination'
import { Table, Button, Modal, Tag, Steps, Popover, Tooltip } from 'antd'
import { QuestionCircleFilled, DeleteOutlined, BarChartOutlined, PieChartOutlined, CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined, StopOutlined, MinusCircleFilled, CloseCircleFilled, CheckCircleFilled, ClockCircleFilled, CheckOutlined, CloseOutlined, SendOutlined, EyeOutlined, NotificationOutlined } from '@ant-design/icons'
import FormModalEmail from './FormModalEmail'
import FormModalSend from './FormModalSend'
import FormModalSendStatistics from './FormModalSendStatistics'
import RejectModal from './RejectModal'
import ViewModal from '../../emailTemplate/components/ViewModal'
import { withTranslation } from 'react-i18next'
import { PAGE_SIZE_DEFAULT } from '../../../constants/appConstant'
const { confirm } = Modal
const { Step } = Steps;

@inject('emailListStore', 'emailTemplateStore')
@observer
class SearchResult extends Component {
  state = {
    emailModalVisible: false,
    sendVisibleAdd: false,
    record: null,
    addModalVisible: false,
    //modalVisibleView: false,
    previewModalVisable: false,//预览
    sendStatisticsModalVisable: false //发送数量统计

  }

  componentDidMount() {
  }
  // 活跃邮箱统计
  handleEmailTotil = (record) => {
    const { emailListStore } = this.props
    const { searchItem } = emailListStore
    emailListStore.onChangeFetching(true)
    emailListStore.onEmailTotalAction({
      "id": record?.id,
      "marketGroupId": searchItem?.marketGroupId || record?.groupId,
      "sn": record?.sn, // 任务批次号
    }).then(res => {
      this.setState({
        emailModalVisible: true,
        record: record
      })
      emailListStore.onChangeFetching(false)
    })
  }
  handleCancelEmailTotil = () => {
    this.setState({
      emailModalVisible: false
    })
  }
  // 发送统计
  handleSendTotil = (record) => {
    const { emailListStore } = this.props
    const { searchItem } = emailListStore
    emailListStore.onChangeFetching(true)
    emailListStore.onSendTotalAction({
      "id": record?.id,
      "marketGroupId": searchItem?.marketGroupId || record?.groupId,
      "sn": record?.sn, // 任务批次号
    }).then(res => {
      this.setState({
        sendVisibleAdd: true,
        record: record
      })
      emailListStore.onChangeFetching(false)
    })
    emailListStore.onFailedStatisticsAction({
      "id": record?.id,
      "marketGroupId": searchItem?.marketGroupId || record?.groupId,
      "sn": record?.sn, // 任务批次号
    })
  }
  handleCancelSendTotil = () => {
    this.setState({
      sendVisibleAdd: false
    })
  }
  handleDel = (record) => {
    const { emailListStore, type, t } = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled />,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        emailListStore.onDeleteJobAction(record?.id, type)
      },
      onCancel() {
      },
    })
    return false
  }
  handleAgree = (record) => {
    const { emailListStore, type, t } = this.props
    const { searchItem } = emailListStore
    confirm({
      title: t(`general.agreeData`),
      icon: <QuestionCircleFilled />,
      content: t(`general.agreeToData`),
      okText: t(`general.agree`),
      cancelText: t(`general.cancel`),
      className: "agree",
      onOk() {
        const params = {
          "approveResult": '3',
          "groupId": searchItem?.marketGroupId || record?.groupId,
          "taskId": record?.id,
        }
        emailListStore.onAgreeAction(params, type)
      },
      onCancel() {
      },
    })
    return false
  }
  handleReject = (record) => {
    this.setState({
      "addModalVisible": true,
      "taskId": record?.id,
      "groupId": record?.groupId,
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  // 失败批次重新发送
  handleResend = (record) => {
    const { emailListStore, type, t } = this.props
    const { searchItem } = emailListStore
    confirm({
      title: t(`general.resendData`),
      icon: <QuestionCircleFilled />,
      content: t(`general.sureToResend`),
      okText: t(`general.resend`),
      cancelText: t(`general.cancel`),
      onOk() {
        emailListStore.onReSendAction({
          "groupId": searchItem?.marketGroupId || record?.groupId,
          "taskId": record?.id,
        }, type)
      },
      onCancel() {
      },
    })
    return false
  }
  // 查看详情
  handleDetails = (record) => {
    this.handleView(record)
  }
  //查看地址
  handleView = (record) => {
    const { emailListStore } = this.props
    const { searchItem } = emailListStore
    emailListStore.onChangeFetching(true)
    emailListStore.onDetailsListAction({
      id: record?.listId,
      taskId: record?.id,
      marketGroupId: searchItem?.marketGroupId || record?.groupId,
      page: 1,
      size: PAGE_SIZE_DEFAULT
    }).then(res => {
      this.setState({
        modalVisibleView: true,
        record: record
      })
      emailListStore.onGetStatus('sourceType')
      emailListStore.onChangeFetching(false)
    })
  }
  handleCancelView = () => {
    this.setState({
      modalVisibleView: false,
      record: null
    })
  }

  //发送统计信息
  handleSendStatistics = (record) => {
    const { emailListStore } = this.props;

    emailListStore.onGetSendStatistics(record?.id)
      .then(res => {
        this.setState({
          sendStatisticsModalVisable: true
        })
      })
  }

  handleCancelSendStatistics = () => {
    this.setState({
      sendStatisticsModalVisable: false
    })
  }
  handlePageChange = (page, pageSize) => {
    const { emailListStore, type } = this.props
    emailListStore.onChangePageNumAction(page, pageSize, type)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  // 预览邮件
  handlePreview = (record) => {
    const { emailTemplateStore, emailListStore, type } = this.props
    const { searchItem } = emailListStore
    emailTemplateStore.onGetJobAction({
      id: type === '1' ? record.templates : record?.templates?.template[0]?.tplId ,
      marketGroupId: type === '1' ? record?.groupId : searchItem?.marketGroupId
    }).then(res => {
      this.setState({
        previewModalVisable: true,
      })
    })
  }
  //关闭预览
  handleCancelPreviewModal = () => {
    this.setState({
      previewModalVisable: false,
    })
  }
  //查看时间间隔
  getIntervalInMinute = (time) => {
    if (time) {
      const beginTime = new Date(time)
      const nowTime = Date.now()
      const interval = Math.floor((nowTime - beginTime) / 1000 / 60)
      return interval ?? 0;
    } else {
      return 0;
    }
  }

  render() {
    const { emailListStore, type, t } = this.props
    const { searchItem, pageNo, pageSize, itemCount, jobList, statusList, groupList, templateList } = emailListStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    const customDot = (dot, { status, index }, stepData) => {
      const { approver, approveTime, approveStatus, refuseReason } = stepData;
      return (
        <Popover
          content={<>
            <div>审批人： {approver} </div>
            <div>审批时间： {approveTime} </div>
            <div>审批状态： {statusList?.find(a => a?.code === approveStatus)?.name}</div>
            {approveStatus === '4' ? <div style={{ wordBreak: 'break-word', wordWrap: 'break-word' }}>原因： {refuseReason} </div> : null}
          </>}
        >
          {!approver ? <MinusCircleFilled style={{ color: 'rgba(0, 0, 0, 0.25)' }} /> : approveStatus === '3' ? <CheckCircleFilled style={{ color: 'green' }} /> : approveStatus === '4' ? <CloseCircleFilled /> : approveStatus === '1' ? <ClockCircleFilled style={{ color: 'rgba(0, 0, 0, 0.25)' }} /> : <MinusCircleFilled />}
        </Popover>
      )
    };
    return (
      <div className="searchResult">
        <Table dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName}>
          <Table.Column width={100} title={t(`emailSend.marketingGroup`)} dataIndex="groupName" key="groupName" ellipsis={true}
                        render={(text, record) => (
                          <>
                            {
                              type === '2'
                                ? groupList?.find(a => a?.id === searchItem?.marketGroupId)?.groupName
                                : record?.groupName
                            }
                          </>
                        )}
          />
          <Table.Column width={100} title={t(`emailSend.taskId`)} dataIndex="id" key="id" ellipsis={true} />
          <Table.Column width={200} title={t(`marketingManagement.taskName`)} dataIndex="taskName" key="taskName" ellipsis={true} />
          {
            type === '1' &&
            <Table.Column width={100} title={t(`emailSend.dataStatus`)} dataIndex="status" key="status" render={(text, record) => {
              const status = statusList?.find(a => a?.code === text)
              return <>
                <Tag color={text === '7' ? 'success' : 'cyan' }>
                  {text === '7' ? <ClockCircleOutlined /> : <StopOutlined />}
                  {' '}
                  {text === '7' ? '邮件上传' : '未开始'}
                </Tag>
              </>
            }
            }/>
          }
          <Table.Column width={100} title={type === '1'?t(`emailSend.actionStatus`):t(`emailSend.status`)} dataIndex={type === '1' ? "status" : "sendStatus"} key={type === '1' ? "status" : "sendStatus"} render={(text, record) => {
            const status = statusList?.find(a => a?.code === text)
            return <>
              < Tag color={text === '3' ? "success" : text === '4' ? "error" : parseInt(text) < 0 ? null : "cyan"}>
                {text ? text === '3' ? <CheckCircleOutlined /> : text === '4' ? <CloseCircleOutlined /> : parseInt(text) < 0 ? <StopOutlined /> : <ClockCircleOutlined /> : null}
                {' '}
                {type === "1" && status?.name == "发送中" ? "已完成" : status?.name}
              </Tag>
              {type === "2" && status?.name == "正在发送" ? <Tag>{record.sendRate ? (record.sendRate.indexOf('%') == -1 ? record.sendRate + '%' : record.sendRate) : ''}</Tag> : null}
            </>
          }
          } />
          <Table.Column width={180} title={t(`emailSend.taskTemplateList`)} dataIndex="templates" key="templates" ellipsis={true} render={(text, record) => {
            const val = text?.template?.map(a => { return a?.tplName })?.join(', ')
            return type === '1' ? templateList.find(b => b?.id === text)?.name : <span title={val}>{val}</span>
          }} />
          {type === '1' ? null : <Table.Column width={90} title={t(`emailSend.bookSendEmail`)} dataIndex="listes" key="listes" ellipsis={true} render={(text, record) => {
            const num = parseInt(record?.sendQtyRemak ?? 0)
            const disabled = this.getIntervalInMinute(record?.timeStart) < 5
            return disabled ? (<><Tooltip placement="top" title={"邮件开始发送5分钟后可以查看发送统计"} ><Button type="link" disabled={disabled} style={{ textDecoration: num > 0 ? 'underline' : null }} onClick={() => this.handleSendStatistics(record)} >{num}</Button></Tooltip></>) : <Button type="link" disabled={disabled} style={{ textDecoration: num > 0 ? 'underline' : null }} onClick={() => this.handleSendStatistics(record)} >{num}</Button>
          }} />}
          {/* <Table.Column title={t(`emailSend.emailTotal`)} dataIndex="groupName" key="groupName" ellipsis={true} render={(text, record) => (
            <>
              打开率: <span style={{color: 'rgb(255, 82, 0)'}}>{ record?.openRatio || '暂无数据'}</span><br />
              成功率: <span style={{color: 'rgb(95, 191, 49)'}}>{ record?.successRatio || '暂无数据'}</span>
            </>
          )}/> */}
          <Table.Column width={100} title={t(`emailSend.sendCount`)} dataIndex="sendCount" key="sendCount" ellipsis={true} />
          {type === '1' ? <Table.Column width={100} title={t(`marketingManagement.approvalStatus`)} dataIndex="approveLogList" key="approveLogList" ellipsis={true} render={(text, record) => (
            <Steps style={{ width: '100%' }} progressDot={(dot, { status, index }) =>
              customDot(dot, { status, index }, text[index])
            }>
              {text?.map((a, i) => {
                return <Step key={i} status={
                  a?.approveStatus === '6' ? 'wait' : a?.approveStatus === '1' ? 'process' : a?.approveStatus === '3' ? 'Finished' : a?.approveStatus === '4' ? 'error'
                    : null} />
              })}
            </Steps>
          )} /> : null}
          {type === '1' ? null : <Table.Column width={160} title={t(`emailSend.taskTime`)} dataIndex="timeStart" key="timeStart" ellipsis={true} render={(text, record) => {
            const status = statusList?.find(a => a?.code === record.sendStatus)
            return <>
              <span title={record?.timeStart}>{record?.timeStart}</span><br />
              {type === "2" && status?.name === "正在发送" ? null : <span title={record?.timeEnd}>{record?.timeEnd}</span>}
            </>
          }} />}
          <Table.Column align="center" width={type === '1' ? 180 : 120} fixed='right' title={t(`general.action`)} Tag={NotificationOutlined} key="Action" render={(text, record) => {
            const disabled = type === '1' || this.getIntervalInMinute(record?.timeStart) < 5
            return (type === '1' ? <>
              <Button type="link" onClick={() => this.handlePreview(record)} icon={<EyeOutlined />} title={t(`general.details`)} />
              {record.btnStatus?.canApprove === '0' ? <>
                <Button type="link" style={{ color: 'green' }} onClick={() => this.handleAgree(record)} icon={<CheckOutlined />} title={t(`general.agree`)} />
                <Button type="link" style={{ color: 'red' }} onClick={() => this.handleReject(record)} icon={<CloseOutlined />} title={t(`general.reject`)} />
              </> : null}
              {record.btnStatus?.canDelete === '0' ? <>
                <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined />} title={t(`general.delete`)} />
              </> : null}
              {record.btnStatus?.canResend === '0' ? <>
                <Button type="link" onClick={() => this.handleResend(record)} icon={<SendOutlined />} title={t(`general.resend`)} />
              </> : null}
              {record.btnStatus?.canDetail === '0' ? <>
                <Button type="link" onClick={() => this.handleDetails(record)} icon={<EyeOutlined />} title={t(`general.details`)} />
              </> : null}
            </> : <>
              <Button type="link" onClick={() => this.handlePreview(record)} icon={<EyeOutlined />} title={t(`general.details`)} />
              {disabled ? <>< Tooltip placement="top" title={"邮件开始发送5分钟后可以查看发送统计"} >
                <Button type="link" disabled={disabled} onClick={() => this.handleEmailTotil(record)} icon={<BarChartOutlined />} title='活跃邮箱统计' />
                <Button type="link" disabled={disabled} onClick={() => this.handleSendTotil(record)} icon={<PieChartOutlined />} title='发送统计' />
              </Tooltip></> : <>
                <Button type="link" onClick={() => this.handleEmailTotil(record)} icon={<BarChartOutlined />} title='活跃邮箱统计' />
                <Button type="link" onClick={() => this.handleSendTotil(record)} icon={<PieChartOutlined />} title='发送统计' />
              </>
              }
            </>
            )
          }
          } />
        </Table >
        {
          this.state.previewModalVisable ?
            <ViewModal
              handleCancel={this.handleCancelPreviewModal}
              addModalVisible={this.state.previewModalVisable}
            />
            : null
        }
        {
          this.state.emailModalVisible ? <FormModalEmail
            addModalVisible={this.state.emailModalVisible}
            handleCancel={this.handleCancelEmailTotil}
            record={this.state.record}
          /> : null
        }
        {
          this.state.sendVisibleAdd ? <FormModalSend
            addModalVisible={this.state.sendVisibleAdd}
            handleCancel={this.handleCancelSendTotil}
            record={this.state.record}
          /> : null
        }
        {
          this.state.addModalVisible ? <RejectModal
            addModalVisible={this.state.addModalVisible}
            handleCancel={this.handleCancel}
            taskId={this.state.taskId}
            groupId={this.state.groupId}
            type={type}
          /> : null
        }
        {/* {this.state.modalVisibleView ? <ViewFormModal
          addModalVisible={this.state.modalVisibleView}
          handleCancel={this.handleCancelView}
          record={this.state.record}
        /> : null} */}
        {
          this.state.sendStatisticsModalVisable ? <FormModalSendStatistics
            addModalVisible={this.state.sendStatisticsModalVisable}
            handleCancel={this.handleCancelSendStatistics}
          /> : null
        }
      </div >
    )
  }
}

export default withTranslation()(SearchResult)
